import { makeStyles } from "@material-ui/core/styles"
import loginBackgroundImage from "../../styles/img/login-background.jpg"

const useLoginStyles = makeStyles((theme) => ({
  loginWrapper: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "stretch",
      backgroundImage: `url(${loginBackgroundImage})`,
      backgroundSize: "contain",
      backgroundPosition: "left"
    },
    [theme.breakpoints.down("md")]: {
      backgroundSize: "130%",
      "& h1": {
        fontSize: "68px"
      },
      "& h2": {
        fontSize: "48px"
      }
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(5),
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      "& h1": {
        fontSize: "42px"
      },
      "& h2": {
        fontSize: "30px",
        marginBottom: theme.spacing(5)
      }
    }
  },
  changePwdForm: {
    width: "100%"
  },
  loginForm: {
    width: "500px",
    [theme.breakpoints.up("md")]: {
      marginRight: theme.spacing(5)
    },
    [theme.breakpoints.down("md")]: {
      margin: `0 ${theme.spacing(2)}px`
    },
    [theme.breakpoints.only("xs")]: {
      width: "96%"
    }
  },
  loginText: {
    [theme.breakpoints.up("md")]: {
      backgroundColor: "var(--white)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      padding: "50px",
      minWidth: "50%",
      maxWidth: "50%"
    }
  },
  loginFormButton: {
    paddingTop: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    // add margin right to all buttons except last one
    "& :not(:last-child)": {
      marginRight: theme.spacing(1)
    },
    "& button": {
      letterSpacing: "normal",
      fontSize: 12
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "column-reverse",
      alignItems: "stretch",
      justifyContent: "space-around",
      width: "100%",
      "& button": {
        fontSize: "10px !important",
        marginTop: theme.spacing(1),
        marginRight: 0 // reset margin right
      },
      "& :not(:last-child)": {
        marginRight: 0
      }
    }
  },
  endAdornmentTooltip: {
    marginRight: 12,
    cursor: "pointer"
  }
}))

export default useLoginStyles
